/**
 * Role Constants
 * 
 * Centralized role definitions to eliminate hardcoded strings.
 * Use these constants throughout the frontend for role checks.
 */

export const ROLES = Object.freeze({
  SUPER_ADMIN: 'super_admin',
  ORG_ADMIN: 'admin',
  MANAGER: 'manager',
  USER: 'user',
  CONTRACTOR: 'contractor'
});

// Role display names for UI
export const ROLE_DISPLAY_NAMES = Object.freeze({
  [ROLES.SUPER_ADMIN]: 'Super Admin',
  [ROLES.ORG_ADMIN]: 'Admin',
  [ROLES.MANAGER]: 'Manager',
  [ROLES.USER]: 'User',
  [ROLES.CONTRACTOR]: 'Contractor'
});

// Role hierarchy (higher index = more privileges)
export const ROLE_HIERARCHY = Object.freeze([
  ROLES.CONTRACTOR,
  ROLES.USER,
  ROLES.MANAGER,
  ROLES.ORG_ADMIN,
  ROLES.SUPER_ADMIN
]);

/**
 * Check if a role has equal or higher privileges than required role
 * @param {string} userRole - The user's current role
 * @param {string} requiredRole - The minimum required role
 * @returns {boolean}
 */
export function hasRoleOrHigher(userRole, requiredRole) {
  const userIndex = ROLE_HIERARCHY.indexOf(userRole?.toLowerCase());
  const requiredIndex = ROLE_HIERARCHY.indexOf(requiredRole?.toLowerCase());
  
  if (userIndex === -1 || requiredIndex === -1) return false;
  return userIndex >= requiredIndex;
}

export default ROLES;
